export type RandomSource = () => number;

const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

/** Deterministic random numbers in [0, 1) for a string seed: FNV-1a (32 bit)
 * hashes the seed, mulberry32 generates the sequence. The same seed always
 * yields the same wobble on every display and every re-render. */
export function seededRandom(seed: string): RandomSource {
  let hash = FNV_OFFSET_BASIS;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, FNV_PRIME);
  }
  let state = hash >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let mixed = state;
    mixed = Math.imul(mixed ^ (mixed >>> 15), mixed | 1);
    mixed ^= mixed + Math.imul(mixed ^ (mixed >>> 7), mixed | 61);
    return ((mixed ^ (mixed >>> 14)) >>> 0) / 4294967296;
  };
}

export function randomBetween(
  random: RandomSource,
  min: number,
  max: number,
): number {
  return min + random() * (max - min);
}
